<style lang="less" scoped>
 .block-contain {
     display: flex;
     // height: 100px;
     .item-right-border {
        // border-right: solid 1px #515a6e;
        position: relative;
     }
     .item-right-border::after {
         content:'';
         position: absolute;
         top: 10%;
         right: 0px;
         height: 80%;
         width: 1px;
         background: white;
         // border-right: solid 1px #515a6e;
     }
     .item {
         padding: 10px;
         flex: 1;
         background: rgb(231,234,237);
         cursor: pointer;
         .title {
            margin-bottom: 0px;
            line-height: 24px;
            font-size: 12px !important;
            font-weight: bold;
            text-align: center;
         }
         .price {
            margin-bottom: 0px;
            height: 40px;
            line-height: 40px;
            font-size: 28px;
            text-align: center;
         }
         .num {
              margin-bottom: 0px;
              text-align: center;
         }
         .iview-green {
             color: green
         }
         .iview-red {
             color: red
         }
     }
 }
</style>
<template>
  <div class="block-contain">
    <div
      v-for="(item,index) in button_fields"
      :key="index"
      class="item"
      :style="{
        'background': index === selected? 'white':''
      }"
      :class="{
        'item-right-border':index !== button_fields.length-1
      }"
      @click="changeSelected(index,item,sourceDataHash[item.key])"
    >
      <p class="title">
        {{ item.title }}
      </p>
      <p class="price">
        {{ ![null,undefined].includes(sourceDataHash[item.key].total)?
          formattingNumber(sourceDataHash[item.key].total,item.key==='unit_price'?1:0,item.key==='income'?10000:1):'-' }}
        <span
          v-show="item.key==='income'"
          style="margin-left:5px;font-size: 16px;"
        >万</span>
      </p>
      <p class="num">
        <span
          :class="{
            'iview-red': sourceDataHash[item.key].isRais,
            'iview-green': !sourceDataHash[item.key].isRais,
          }"
        >
          {{ `${sourceDataHash[item.key].isRais?
            '↑':'↓'}${sourceDataHash[item.key].percent!==undefined? 
            sourceDataHash[item.key].percent:'-'}% | ${sourceDataHash[item.key].num!==undefined? 
            formattingNumber(sourceDataHash[item.key].num,item.key==='unit_price'?1:0,item.key==='income'?10000:1):'-'}` }}
          <span
            v-show="item.key==='income'"
            style="margin-left:0px;font-size: 10px;"
          >万</span>
        </span>
      </p>
    </div>
  </div>
</template>
<script>
  import { BUTTON_FIELDS, default_hash_data } from './overview_fields'
  import { formattingNumber } from './../utils'
  import { setButtonData } from './over_vivew_utils'
  export default {
    props: {
      sourceData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      this.myChart = null // echarts 容器
      this.button_fields = BUTTON_FIELDS
      return {
        selected: 0
      }
    },
    computed: {
      sourceDataHash() {
        if (!this.sourceData) {
          return default_hash_data
        }
        return {
          income: setButtonData(this.sourceData.income),
          user: setButtonData(this.sourceData.user),
          old_user: setButtonData(this.sourceData.old_user),
          new_user: setButtonData(this.sourceData.new_user),
          unit_price: setButtonData(this.sourceData.unit_price),
        }
      }
    },
    methods:{
      formattingNumber:formattingNumber,
      changeSelected(index) {
        this.selected = index
        this.$emit('changeSelected', index)
      },
    }
  }
</script>
